module.exports = __webpack_public_path__ + "static/media/nosotros_section_two_image.a0d7791f.png";